import React from 'react';
import { Card, Text, Pill, mergeClassNames } from '@clockout-dev/design-elements';
import { formatNumberWithCommas, formatFullCurrency } from '../../../utils/numbers';
import styles from './styles/kpi-card.module.scss';

function KpiCard({ label, value, variant = 'default', conversionRate, icon, isCurrency = false, onClick }) {
    const isFeatured = variant === 'featured';
    const clickable = typeof onClick === 'function';
    const displayValue = typeof value === 'string'
        ? value
        : isCurrency ? formatFullCurrency(value) : formatNumberWithCommas(value);

    const card = (
        <Card className={mergeClassNames([styles.card, isFeatured && styles.featured])}>
            <div className={mergeClassNames([styles.topRow])}>
                {icon ? <span className={styles.icon}>{icon}</span> : null}
                {conversionRate ? (
                    <Pill
                        size="small"
                        text={conversionRate}
                        textSize="xs"
                        classNames={{ root: styles.crPill, text: styles.crPillText }}
                    />
                ) : null}
            </div>
            <div className={styles.body}>
                <Text as="span" className={styles.label}>{label}</Text>
                <Text as="span" className={styles.value}>{displayValue}</Text>
            </div>
        </Card>
    );

    if (!clickable) return card;

    return (
        <div
            className={styles.clickable}
            role="button"
            tabIndex={0}
            aria-label={`View ${label} users`}
            onClick={onClick}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onClick(e);
                }
            }}
        >
            {card}
        </div>
    );
}

export default KpiCard;
